/* Xinzuo v2 product page, below the fold and floating add to cart (workstream pdp).
   Plain deferred script, no dependencies. Every custom element cleans up on
   disconnect so theme-editor section reloads never duplicate listeners. */
(function () {
  if (window.__xzV2WsPdp) return;
  window.__xzV2WsPdp = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Scroll-into-view triggers (see checkPending); declared first because rails arm their
     headers from connectedCallback while this script is still defining them. */
  var TRIGGERS = [
    { sel: '.xz-v2-pdpx [data-xz-rise].is-rise-armed:not(.is-risen)', offset: 0.24, cls: 'is-risen' },
    { sel: '.xz-v2-pdpx [data-xz-feat]:not(.is-feat-in)', offset: 0.16, cls: 'is-feat-in' }
  ];
  var listening = false;

  /* Keyboard focus in a horizontal rail (sets carousel, "More from this series", phone gallery thumbs): Chrome
     treats a card that is only a sliver inside the page as already visible (the rail's box runs past the
     viewport, which overflow-x:clip cannot scroll), so Tab left the focus ring on a 10% sliver. Scroll the
     nearest horizontal scroller until the focused card sits inside both the rail and the viewport, 16px clear.
     Keyboard only (:focus-visible), so mouse drag and touch stay as they are. */
  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    try { if (!target.matches(':focus-visible')) return; } catch (e) { return; }
    var scroller = target.parentElement;
    while (scroller && scroller !== document.body) {
      if (scroller.scrollWidth > scroller.clientWidth + 1) {
        var ox = getComputedStyle(scroller).overflowX;
        if (ox === 'auto' || ox === 'scroll') break;
      }
      scroller = scroller.parentElement;
    }
    if (!scroller || scroller === document.body) return;
    /* The phone gallery track pages whole photos (scroll snapping, xz-v2-pdp-shopping.js moves it to the focused
       photo): nudging a full-width slide 16px would fight the snap. */
    if (scroller.hasAttribute('data-xz-track')) return;
    var sr = scroller.getBoundingClientRect();
    var left = Math.max(sr.left, 0) + 16, right = Math.min(sr.right, document.documentElement.clientWidth) - 16;
    /* The card: climb only through same-width wrappers (the link -> its card box), never into the track. */
    var item = target;
    while (item.parentElement && item.parentElement !== scroller && item.parentElement.getBoundingClientRect().width <= item.getBoundingClientRect().width + 1) item = item.parentElement;
    var r = item.getBoundingClientRect();
    var delta = r.right > right ? Math.min(r.right - right, r.left - left) : (r.left < left ? r.left - left : 0);
    if (delta) scroller.scrollLeft += delta;
  });

  /* Rails: prev/next circles scroll one card, mouse drag scrolls, touch stays native. */
  if (!customElements.get('xz-v2-rail')) {
    customElements.define('xz-v2-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-xz-rail-track]');
        if (!this.track || this.abort) return;
        this.abort = new AbortController();
        var signal = this.abort.signal;
        var track = this.track;
        var self = this;
        this.addEventListener('click', function (event) {
          var prev = event.target.closest('[data-xz-rail-prev]');
          var next = event.target.closest('[data-xz-rail-next]');
          if (!prev && !next) return;
          var card = track.querySelector('li:not(.ff-carousel-end-space), .ff-carousel-box-416-90');
          var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
          track.scrollBy({ left: next ? step : -step, behavior: reduceMotion ? 'auto' : 'smooth' });
        }, { signal: signal });
        var dragging = false, moved = false, startX = 0, startLeft = 0;
        track.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragging = true; moved = false; startX = event.clientX; startLeft = track.scrollLeft;
          /* Milen's carousels show the grabbing hand from the press, not from the first move. */
          track.classList.add('is-pressed');
        }, { signal: signal });
        window.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          var dx = event.clientX - startX;
          if (Math.abs(dx) > 3) { moved = true; track.classList.add('is-dragging'); }
          if (moved) { track.scrollLeft = startLeft - dx; event.preventDefault(); }
        }, { signal: signal });
        window.addEventListener('pointerup', function () {
          if (!dragging) return;
          dragging = false;
          track.classList.remove('is-dragging', 'is-pressed');
        }, { signal: signal });
        track.addEventListener('click', function (event) {
          if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; }
        }, { signal: signal, capture: true });
        track.addEventListener('dragstart', function (event) { event.preventDefault(); }, { signal: signal });
        /* Arrows only when there is something to scroll to (a 3-card rail on a wide screen fits).
           A rail that fits from Milen's bleed start (64px) would sit stranded left of the text
           frame, so it starts on the frame's left edge instead (and may still bleed right). */
        var pad = track.firstElementChild;
        var sizeCheck = function () {
          /* Same check the rail already ran while parsing (snippets/xz-v2-rail-fit.liquid). */
          if (window.xzV2RailFit) { window.xzV2RailFit(self); return; }
          if (pad) pad.style.paddingLeft = '';
          self.classList.remove('is-framed');
          var fits = track.scrollWidth <= track.clientWidth + 2;
          if (fits && pad) {
            var section = self.closest('.shopify-section') || self;
            var frame = self.querySelector('.ff-is-max-width') || section.querySelector('.ff-is-max-width');
            if (frame) {
              var base = parseFloat(window.getComputedStyle(pad).paddingLeft) || 0;
              var offset = Math.round(frame.getBoundingClientRect().left - track.getBoundingClientRect().left);
              if (offset > base + 1) {
                pad.style.paddingLeft = offset + 'px';
                self.classList.add('is-framed');
                fits = track.scrollWidth <= track.clientWidth + 2;
              }
            }
          }
          self.classList.toggle('is-static', fits);
        };
        window.addEventListener('resize', sizeCheck, { passive: true, signal: signal });
        window.addEventListener('load', sizeCheck, { signal: signal });
        sizeCheck();
        self.observeRise();
      }
      observeRise() { observeRise(this); }
      disconnectedCallback() { if (this.abort) this.abort.abort(); this.abort = null; }
    });
  }

  /* Customer Reviews (Judge.me renders the list after load), Milen's final /pdp layout (2 Oct): summary,
     histogram and masonry cards restyled in xz-v2-pdpf-below.css. This element keeps Judge.me's text in his
     wording (two-decimal average, "Reviews"), sizes the sort chevron and owns the reload/Back copy. */
  if (!customElements.get('xz-v2-reviews')) {
    customElements.define('xz-v2-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        var signal = this.abort.signal;
        var self = this;
        var timer = null;
        var schedule = function () { clearTimeout(timer); timer = setTimeout(function () { self.refresh(); }, 60); };
        this.observer = new MutationObserver(schedule);
        this.observer.observe(this, { childList: true, subtree: true });
        window.addEventListener('resize', schedule, { passive: true, signal: signal });
        window.addEventListener('load', schedule, { signal: signal });
        /* Reload / Back: Judge.me fills this widget ~1.5s after the first paint (+1000px). The layout head script
           reserves the height it had when the shopper left (--xz-v2-reviews-h), so the restored scroll position
           shows the same content and nothing moves when the reviews arrive. Remember it on the way out; release
           the reservation once Judge.me has filled it (or 6s after load). */
        this.holdKey = 'xz-v2-reviews-h:' + location.pathname + ':' + window.innerWidth;
        window.addEventListener('pagehide', function () { self.remember(); }, { signal: signal });
        window.addEventListener('load', function () { setTimeout(function () { self.releaseHold(); self.unsnap(true); }, 6000); }, { signal: signal });
        this.addEventListener('change', function (event) {
          if (event.target.matches && event.target.matches('select.jdgm-sort-dropdown')) self.sizeSort(event.target);
        }, { signal: signal });
        /* Judge.me's LOAD MORE is an <a role=button> without href: refresh() makes it focusable; Enter / Space click it. */
        this.addEventListener('keydown', function (event) {
          var more = event.target.closest && event.target.closest('.jdgm-paginate__load-more');
          if (!more || (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar')) return;
          event.preventDefault();
          self.moreByKey = Date.now();
          more.click();
        }, { signal: signal });
        /* The sort label is measured with Euclid: measure again once the web fonts are in. */
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (self.abort) self.refresh(); });
        this.refresh();
      }
      /* The live widget's blocks (not the stored copy shown on reload/Back). */
      live() {
        var frame = this.querySelector('.xz-v2-pdp-reviews-widget');
        return frame ? Array.prototype.filter.call(frame.children, function (node) { return !node.classList.contains('xz-v2-reviews-snap') && node.tagName !== 'SCRIPT'; }) : [];
      }
      /* Height of the widget's content, independent of the reserved min-height. */
      contentHeight() {
        var live = this.live();
        if (!live.length || !this.querySelector('.xz-v2-pdp-reviews-widget > :not(.xz-v2-reviews-snap) .jdgm--done-setup')) return 0;
        var top = live[0].getBoundingClientRect().top;
        return Math.round(live[live.length - 1].getBoundingClientRect().bottom - top);
      }
      remember() {
        var h = this.contentHeight();
        try { if (h > 0) sessionStorage.setItem(this.holdKey, String(h)); } catch (e) {}
        /* The settled widget as markup, for the next reload/Back at this width (one entry, the latest page). */
        var frame = this.querySelector('.xz-v2-pdp-reviews-widget');
        if (!h || !frame || frame.classList.contains('is-snap')) return;
        var html = this.live().map(function (node) {
          var clone = node.cloneNode(true);
          clone.querySelectorAll('style, script, link').forEach(function (el) { el.remove(); });
          return clone.outerHTML;
        }).join('');
        /* Judge.me styles most of its widget from stylesheets, rules and an icon font its script appends to <body>
           late; the copy needs them at the first paint, so they go with it, in order (layout/theme.liquid loads the
           stylesheets render-blocking in <head> and applies them at the end of <body>, Judge.me's position). */
        var seq = [];
        Array.prototype.forEach.call(document.body.children, function (el) {
          if (el.hasAttribute('data-xz-v2-snap')) return;
          if (el.tagName === 'LINK' && el.rel === 'stylesheet' && /judgeme|jdgm/i.test(el.href)) seq.push({ h: el.href });
          else if (el.tagName === 'STYLE' && /jdgm/.test(el.textContent) && !/jdgm-(settings|miracle)-style|jdgm-temp-hiding-style|xz-v2-reviews-snap-style/.test(el.className)) seq.push({ t: el.textContent });
        });
        var fonts = (performance.getEntriesByType ? performance.getEntriesByType('resource') : [])
          .map(function (entry) { return entry.name; })
          .filter(function (url) { return /judgeme|jdgm/i.test(url) && /\.(woff2?|ttf|otf)(\?|$)/i.test(url); });
        try {
          if (html.length < 400000) {
            sessionStorage.setItem('xz-v2-reviews-snap', JSON.stringify({ k: this.holdKey, html: html }));
            /* Apart: the <head> reads these without parsing the copy. */
            sessionStorage.setItem('xz-v2-reviews-assets', JSON.stringify({ k: this.holdKey, seq: seq, fonts: fonts }));
          }
        } catch (e) {}
      }
      /* Swap the stored copy for the live widget once Judge.me has built it and it has held its height for two
         checks (its setup runs in steps over ~0.5s), or 6s after load at the latest. */
      unsnap(force) {
        var frame = this.querySelector('.xz-v2-pdp-reviews-widget');
        if (!frame || !frame.classList.contains('is-snap')) return;
        /* Never before the load event: Chrome re-applies the saved scroll offset there, so any height the swap
           changes above the view before it (Judge.me's settled widget can differ from the copy by a few px) would
           turn scroll anchoring's silent correction into a jump. After it, anchoring keeps the view still. */
        if (!this.afterLoad) {
          if (!this.waitLoad) {
            this.waitLoad = true;
            var self = this;
            var go = function () { setTimeout(function () { self.afterLoad = true; self.unsnap(force); }, 0); };
            if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
          }
          return;
        }
        var h = this.contentHeight();
        if (!force && (!h || h !== this.snapH)) { this.snapH = h; clearTimeout(this.snapTimer); this.snapTimer = setTimeout(this.unsnap.bind(this, false), 250); return; }
        var copy = frame.querySelector(':scope > .xz-v2-reviews-snap');
        if (copy) copy.remove();
        frame.classList.remove('is-snap');
      }
      releaseHold() {
        var root = document.documentElement;
        if (root.style.getPropertyValue('--xz-v2-reviews-h')) root.style.removeProperty('--xz-v2-reviews-h');
      }
      refresh() {
        this.unsnap(false);
        var held = parseFloat(document.documentElement.style.getPropertyValue('--xz-v2-reviews-h')) || 0;
        if (held && this.contentHeight() >= held - 2) this.releaseHold();
        /* Milen: "4.91 out of 5" (two decimals) and "Based on 127 Reviews"; Judge.me writes "4.9" and "reviews". */
        var self = this;
        var q = function (sel) { var live = self.live(); for (var i = 0; i < live.length; i++) { var hit = live[i].querySelector(sel); if (hit) return hit; } return null; };
        var widget = q('.jdgm-rev-widg[data-average-rating]');
        var avg = widget ? parseFloat(widget.getAttribute('data-average-rating')) : NaN;
        var average = q('.jdgm-rev-widg__summary-average a') || q('.jdgm-rev-widg__summary-average');
        if (average && !average.children.length) {
          var m = average.textContent.match(/(\d+(?:\.\d+)?)\s*out of 5/);
          if (m) {
            var two = (isNaN(avg) ? parseFloat(m[1]) : avg).toFixed(2);
            var text = average.textContent.replace(m[1], two);
            if (text !== average.textContent) average.textContent = text;
          }
        }
        var stars = q('.jdgm-rev-widg__summary-stars[aria-label]');
        if (stars && !isNaN(avg)) {
          var label = stars.getAttribute('aria-label').replace(/\d+(?:\.\d+)?/, avg.toFixed(2));
          if (label !== stars.getAttribute('aria-label')) stars.setAttribute('aria-label', label);
        }
        var based = q('.jdgm-rev-widg__summary-text');
        if (based && based.firstChild && based.firstChild.nodeType === 3) {
          var t = based.firstChild.nodeValue.replace(/\breviews\b/, 'Reviews').replace(/\breview\b/, 'Review');
          if (t !== based.firstChild.nodeValue) based.firstChild.nodeValue = t;
        }
        var sort = q('select.jdgm-sort-dropdown');
        if (sort) this.sizeSort(sort);
        var live = this.live();
        for (var i = 0; i < live.length; i++) {
          var more = live[i].querySelectorAll('.jdgm-paginate__load-more:not([tabindex])');
          for (var j = 0; j < more.length; j++) more[j].setAttribute('tabindex', '0');
        }
        /* Judge.me replaces the pagination after loading the next page: keep keyboard focus on the new LOAD MORE. */
        if (this.moreByKey && Date.now() - this.moreByKey < 8000 && (!document.activeElement || document.activeElement === document.body || !document.activeElement.isConnected)) {
          var next = this.querySelector('.xz-v2-pdp-reviews-widget > :not(.xz-v2-reviews-snap) .jdgm-paginate__load-more[tabindex]');
          if (next && next.offsetParent) { this.moreByKey = 0; next.focus({ preventScroll: true }); }
        }
      }
      /* The sort chevron sits 8px after the centred label (Milen .xz-dropdown-btn): pass the label width to the CSS. */
      sizeSort(select) {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var cs = window.getComputedStyle(select);
        var ctx = this.canvas || (this.canvas = document.createElement('canvas').getContext('2d'));
        /* The touch rule renders 16px and scales by .875: measure at the design size. */
        ctx.font = cs.fontWeight + ' 14px ' + cs.fontFamily;
        if (document.fonts && document.fonts.check && !document.fonts.check(ctx.font, option.text)) return;
        var w = Math.round(ctx.measureText(option.text.toUpperCase()).width * 100) / 100;
        var value = w + 'px';
        if (select.style.getPropertyValue('--xz-sort-w') !== value) select.style.setProperty('--xz-sort-w', value);
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.abort = null;
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }
    });
  }

  /* FAQ band (PDP and knife landing): the question and the circle button both toggle the answer. */
  function toggleFaq(item) {
    var answer = item.querySelector('.sx-answer-wrp');
    if (!answer) return;
    var open = answer.hasAttribute('hidden');
    if (open) answer.removeAttribute('hidden'); else answer.setAttribute('hidden', '');
    item.classList.toggle('is-open', open);
    item.querySelectorAll('[data-xz-faq-toggle][aria-expanded]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
    });
  }
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-xz-faq-toggle]');
    if (!toggle) return;
    var item = toggle.closest('[data-xz-faq]');
    if (item) toggleFaq(item);
  });
  /* Milen 1_7 (8 Oct): "make the entire container of a single question (and answer) clickable to open and close"
     (.xz-faq-single-wrp). A container click runs the same toggle; the question button stays the one keyboard/ARIA
     control (no role or tabindex on the container). Left alone: a click on a control inside the item (the question and
     circle buttons go through the document listener above, so they toggle once; answer links navigate), one that ends
     a text selection inside the item, a modified click, and the repeat clicks of a double/triple click (word selection
     after the first click has toggled). The listener sits on each container, because iOS Safari sends no click to a
     plain element whose only listener is delegated from the document; editor section reloads bind their new items. */
  var FAQ_CONTROLS = 'a[href],button,input,select,textarea,label,summary,details,iframe,video,audio,[contenteditable],[tabindex],[role=button],[role=link]';
  function faqContainerClick(event) {
    var item = event.currentTarget;
    if (event.defaultPrevented || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.detail > 1) return;
    var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var control = target && target.closest(FAQ_CONTROLS);
    if (control && item.contains(control)) return;
    var selection = window.getSelection ? window.getSelection() : null;
    if (selection && !selection.isCollapsed) {
      for (var i = 0; i < selection.rangeCount; i++) if (selection.getRangeAt(i).intersectsNode(item)) return;
    }
    toggleFaq(item);
  }
  function bindFaqItems(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-xz-faq]').forEach(function (item) {
      if (item.xzFaqBound) return;
      item.xzFaqBound = true;
      item.addEventListener('click', faqContainerClick);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bindFaqItems(document); }); else bindFaqItems(document);
  document.addEventListener('shopify:section:load', function (event) { bindFaqItems(event.target); });

  /* Afterpay info disclosure: Escape or a click/tap outside closes it. */
  function closeAfterpay(except) {
    document.querySelectorAll('details.xz-v2-afterpay-info[open]').forEach(function (d) {
      if (d !== except) d.open = false;
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var open = document.querySelector('details.xz-v2-afterpay-info[open]');
    if (!open) return;
    open.open = false;
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });
  document.addEventListener('click', function (event) {
    var inside = event.target.closest && event.target.closest('details.xz-v2-afterpay-info');
    closeAfterpay(inside);
  });

  /* Gift card "Send to" chips: mirror the checked radio on its label (no :has in old Chrome). */
  function syncChoiceLabels(root) {
    (root || document).querySelectorAll('.xz-v2-pdp .gift-card-form-option__button-label').forEach(function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-checked', !!(input && input.checked));
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('.gift-card-form-option')) syncChoiceLabels();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncChoiceLabels(); }); else syncChoiceLabels();

  /* Scroll-into-view triggers checked like Webflow IX2 (scroll listener, same frame): an element
     plays once its top is `offset` of the viewport height above the viewport bottom. Checks only
     read rects (no writes before them), and the listener detaches when nothing is pending.
     An IntersectionObserver lands a frame later and started reveals 2-3 frames behind Milen. */
  /* Queried on every check (not cached): a rail or editor re-render can replace an armed node. */
  function checkPending() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var hits = [];
    var left = 0;
    TRIGGERS.forEach(function (trigger) {
      document.querySelectorAll(trigger.sel).forEach(function (node) {
        var rect = node.getBoundingClientRect();
        if (rect.top < vh * (1 - trigger.offset) || rect.bottom < 0) hits.push([node, trigger.cls]);
        else left += 1;
      });
    });
    hits.forEach(function (hit) { hit[0].classList.add(hit[1]); });
    if (!left && listening) {
      window.removeEventListener('scroll', checkPending);
      window.removeEventListener('resize', checkPending);
      listening = false;
    }
  }
  function listen() {
    if (listening) return;
    window.addEventListener('scroll', checkPending, { passive: true });
    window.addEventListener('resize', checkPending, { passive: true });
    listening = true;
  }
  /* Header entrance: 5px rise and fade, staggered 0/200/400ms (Milen titles-3, a-13, 24% offset).
     The hidden start comes from CSS before the first paint (html.xz-v2-js); arming only marks a header
     as pending, so .is-risen is the one class change and it always animates in, never out. */
  function observeRise(root) {
    if (reduceMotion) return;
    (root || document).querySelectorAll('.xz-v2-pdpx [data-xz-rise]:not(.is-rise-armed)').forEach(function (node) {
      node.classList.add('is-rise-armed');
    });
    listen();
    checkPending();
  }
  /* Promises row (Milen a-50 "features-appear", 16% offset, e-1423): the CSS holds the tiles 10px low and
     transparent under html.xz-v2-feat-js; .is-feat-in plays the staggered 1.6s rise once. */
  function observeFeat(root) {
    (root || document).querySelectorAll('.xz-v2-pdpx [data-xz-feat]:not(.is-feat-in)').forEach(function (row) {
      if (reduceMotion) row.classList.add('is-feat-in');
    });
    listen();
    checkPending();
  }
  function initRise() { observeRise(document); observeFeat(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRise); else initRise();
  document.addEventListener('shopify:section:load', function (event) { observeRise(event.target); observeFeat(event.target); });

  /* Keep the knife-landing CTA price and the floating add to cart's price in step with the selected variant
     (the hero's price: the sale price on a sale; Milen's button shows no compare-at price). */
  function syncPrices(pdp) {
    var price = pdp && pdp.querySelector('.ff-price-rrp-1');
    if (!price) return;
    var text = price.textContent.trim();
    document.querySelectorAll('[data-klp-price], .xz-v2-pdp-sticky-portal [data-sticky-price]').forEach(function (node) {
      if (node.textContent.trim() !== text) node.textContent = text;
    });
  }

  /* Engraving switched on with no text, or two lines chosen with line 2 left empty: every buy path (main
     button, knife-landing buy strip, sticky bar) and DONE stops, scrolls to the empty box and says why,
     instead of adding an unengraved knife or quietly dropping to one line. */
  function engravingMissingInput(pdp) {
    if (!pdp) return null;
    var on = pdp.querySelector('[data-v2-engraving-switch][aria-checked="true"]');
    var state = pdp.querySelector('#engrave-state');
    if (!on && !(state && state.checked)) return null;
    var panel = pdp.querySelector('#engrave-div');
    if (!panel || panel.style.display === 'none') return null;
    var input = pdp.querySelector('#engravedInput');
    if (input && !input.value.trim()) return input;
    var two = pdp.querySelector('#btn-two-lines');
    var input2 = pdp.querySelector('#engravedInput2');
    if (two && two.classList.contains('selected') && input2 && !input2.value.trim()) return input2;
    return null;
  }
  function engravingNeedsText(pdp) { return !!engravingMissingInput(pdp); }
  var ENGRAVE_MESSAGES = {
    engravedInput: 'Enter your engraving, or switch engraving off.',
    engravedInput2: 'Enter line 2, or remove the second line.'
  };
  /* The message joins the input's own aria-describedby (its character-count / hint ids) and leaves it again
     on clear, token by token, so the input keeps its other descriptions. */
  function describedBy(input, id, on) {
    var ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (t) { return t && t !== id; });
    if (on) ids.push(id);
    if (ids.length) input.setAttribute('aria-describedby', ids.join(' ')); else input.removeAttribute('aria-describedby');
  }
  function clearEngraveMsg(msg) {
    if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
    if (msg && msg.__xzInput) { msg.__xzInput.removeEventListener('input', msg.__xzClear); describedBy(msg.__xzInput, msg.id, false); msg.__xzInput.removeAttribute('aria-invalid'); }
  }
  function promptEngraving(pdp) {
    var input = engravingMissingInput(pdp) || pdp.querySelector('#engravedInput');
    if (!input) return;
    var group = input.closest('.input-group') || input.parentNode;
    var msg = pdp.querySelector('.xz-v2-engrave-msg');
    if (msg && msg.__xzInput !== input) { clearEngraveMsg(msg); msg = null; }
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'xz-v2-engrave-msg';
      msg.id = 'xz-v2-engrave-msg';
      msg.setAttribute('role', 'alert');
      msg.innerHTML = '<span class="ff-bullet" aria-hidden="true"></span><span class="ff-caption-1"></span>';
      msg.lastChild.textContent = ENGRAVE_MESSAGES[input.id] || ENGRAVE_MESSAGES.engravedInput;
      group.parentNode.insertBefore(msg, group.nextSibling);
      msg.__xzInput = input;
      msg.__xzClear = function () { clearEngraveMsg(msg); };
      input.addEventListener('input', msg.__xzClear);
      describedBy(input, msg.id, true);
      input.setAttribute('aria-invalid', 'true');
    }
    input.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 400);
  }
  /* Also used by DONE (xz-v2-pdp-shopping.js), which passes its own page. */
  window.xzV2PdpEngravingGuard = function (scope) {
    var pdp = scope || document.querySelector('xz-v2-pdp');
    if (!engravingNeedsText(pdp)) return false;
    promptEngraving(pdp);
    return true;
  };
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.product-form-buttons .add-to-cart-button');
    if (!button || button.closest('dialog') || button.closest('[data-v2-accessory-form]')) return;
    var pdp = button.closest('xz-v2-pdp');
    if (!engravingNeedsText(pdp)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    promptEngraving(pdp);
  }, true);
  /* Switching engraving off or going back to one line ("Remove second line" clicks #btn-one-line) clears a
     message that no longer applies. */
  document.addEventListener('click', function (event) {
    var off = event.target.closest && event.target.closest('[data-v2-engraving-switch], #btn-no-engraving, #btn-one-line');
    if (!off) return;
    setTimeout(function () {
      var pdp = off.closest('xz-v2-pdp');
      var msg = pdp && pdp.querySelector('.xz-v2-engrave-msg');
      if (msg && engravingMissingInput(pdp) !== msg.__xzInput) clearEngraveMsg(msg);
    }, 0);
  });

  /* Breadcrumb: when even the ellipsised product crumb would be cut short (long names at
     320px), the series crumb steps out; the series is named again under the H1. */
  function fitCrumbs() {
    document.querySelectorAll('.xz-v2-pdp .ff-breadcrumbs-wrp').forEach(function (nav) {
      nav.classList.remove('is-compact', 'is-wrap');
      var last = nav.lastElementChild && nav.lastElementChild.querySelector('.ff-caption-breadcrumb');
      var cut = function () { return last && last.scrollWidth > last.clientWidth + 1; };
      if (nav.querySelector('.xz-v2-crumb-series') && cut()) nav.classList.add('is-compact');
      if (cut()) nav.classList.add('is-wrap');
    });
  }
  var crumbTimer = null;
  window.addEventListener('resize', function () { clearTimeout(crumbTimer); crumbTimer = setTimeout(fitCrumbs, 100); }, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitCrumbs);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitCrumbs); else fitCrumbs();
  document.addEventListener('shopify:section:load', fitCrumbs);

  /* Colour / denomination chips navigate to ?variant= (full reload); keep the shopper where
     they were instead of jumping back to the top. */
  var VARIANT_KEY = 'xzV2PdpVariantScroll';
  /* Gift card: the amount chips reload the page too, which reset "Send to" to MY EMAIL and emptied the recipient
     fields, so a card meant for someone else went to the buyer's own email (live changes the amount in place and
     keeps them). The choice and the typed details ride the same reload: same path, 15 s, read once. */
  var GIFT_KEY = 'xzV2PdpGiftRecipient';
  var GIFT_FIELDS = { email: 'recipientEmail', name: 'recipientName', message: 'recipientMessage', sendOn: 'recipientSendOn' };
  var restoreVariantScroll = null;
  function giftRecipientForm(from) {
    var pdp = from && from.closest && from.closest('xz-v2-pdp');
    return (pdp && pdp.querySelector('gift-card-recipient-form')) || document.querySelector('.xz-v2-pdp gift-card-recipient-form');
  }
  function saveGiftRecipient(chip) {
    var form = giftRecipientForm(chip);
    if (!form) return;
    var to = form.querySelector('[ref="recipientEmailButton"]');
    try {
      if (!to || !to.checked) { sessionStorage.removeItem(GIFT_KEY); return; }
      var data = { path: location.pathname, t: Date.now(), mode: 'recipient_form' };
      Object.keys(GIFT_FIELDS).forEach(function (key) {
        var field = form.querySelector('[ref="' + GIFT_FIELDS[key] + '"]');
        data[key] = field ? field.value : '';
      });
      sessionStorage.setItem(GIFT_KEY, JSON.stringify(data));
    } catch (e) {}
  }
  function restoreGiftRecipient(gift) {
    var form = giftRecipientForm(null);
    var to = form && form.querySelector('[ref="recipientEmailButton"]');
    if (!to) return;
    to.checked = true;
    /* component.js routes the change to toggleRecipientForm('recipient_form'): fields enabled, control flag and
       time-zone offset added. Then the values, each with an input event (the message's character count). */
    to.dispatchEvent(new Event('change', { bubbles: true }));
    Object.keys(GIFT_FIELDS).forEach(function (key) {
      var field = form.querySelector('[ref="' + GIFT_FIELDS[key] + '"]');
      if (!field || typeof gift[key] !== 'string' || !gift[key]) return;
      field.value = gift[key];
      field.dispatchEvent(new Event('input', { bubbles: true }));
    });
    /* The toggle focuses the email box (scrolling to it); a reload leaves focus on the page, and the shopper
       stays where they were. */
    var active = document.activeElement;
    if (active && form.contains(active) && active.blur) active.blur();
    if (restoreVariantScroll) restoreVariantScroll();
  }
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('.xz-v2-pdp variant-picker a.product-variant[href]');
    if (!chip) return;
    try { sessionStorage.setItem(VARIANT_KEY, JSON.stringify({ path: location.pathname, y: window.pageYOffset, t: Date.now() })); } catch (e) {}
    saveGiftRecipient(chip);
  }, true);
  try {
    var saved = JSON.parse(sessionStorage.getItem(VARIANT_KEY) || 'null');
    sessionStorage.removeItem(VARIANT_KEY);
    if (saved && saved.path === location.pathname && Date.now() - saved.t < 15000 && /[?&]variant=/.test(location.search)) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var restore = function () { window.scrollTo(0, saved.y); };
      restoreVariantScroll = restore;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore); else restore();
      // The entry goes back to the browser's own restoration once this document is placed, so a later reload
      // or Back to it is restored in its first frame.
      window.addEventListener('load', function () { restore(); history.scrollRestoration = 'auto'; restoreVariantScroll = null; }, { once: true });
    }
  } catch (e) {}
  try {
    var gift = JSON.parse(sessionStorage.getItem(GIFT_KEY) || 'null');
    sessionStorage.removeItem(GIFT_KEY);
    if (gift && gift.mode === 'recipient_form' && gift.path === location.pathname && Date.now() - gift.t < 15000 &&
        /[?&]variant=/.test(location.search) && window.customElements) {
      customElements.whenDefined('gift-card-recipient-form').then(function () {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { restoreGiftRecipient(gift); }, { once: true });
        else restoreGiftRecipient(gift);
      });
    }
  } catch (e) {}

  /* Milen 1_7 floating add to cart (blocks/xz-v2-pdp-sticky.liquid; his 8 Oct answers: restyle the existing bar,
     follow the design, not its comments, and hide at the footer). Trigger: his .xz-pdp-sc2 is the section after the
     hero; on v2 that is whichever renders first after the hero (sc2, sc3, sc4, the reviews or the gift card band),
     so the trigger is the hero's bottom edge, which is that section's top. It shows once that edge is 300px above
     the bottom of the screen, stays shown further down, and hides above it and while the footer group is on screen.
     His animation: opacity and a 20px rise, 300ms, (.25,.46,.45,.94), starting from wherever a reversed one had
     got to; reduced motion fades only. The wrapper is inert while hidden or leaving. */
  var STICKY_OFFSET = 300, STICKY_MS = 300, STICKY_EASE = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  if (!customElements.get('xz-v2-pdp-sticky')) {
    customElements.define('xz-v2-pdp-sticky', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.pdp = this.closest('xz-v2-pdp') || document.querySelector('xz-v2-pdp');
        this.main = this.pdp && this.pdp.querySelector('.product-form-buttons .add-to-cart-button');
        /* Portal to <body>: the PDP section is its own stacking context, so a fixed button inside it would
           paint under the sections that follow. The block's inline script moves the wrapper while parsing (a
           reload/Back can then show it in the first frame); otherwise (editor) it moves here. It moves back on
           disconnect so theme-editor reloads keep working. */
        var early = this.xzV2Portal && this.xzV2Portal.isConnected ? this.xzV2Portal : null;
        this.xzV2Portal = null;
        var wrap = early || this.querySelector('[data-sticky-wrap]');
        /* The block's pre-hydration tap (scroll to the main button) steps aside: from here a tap buys, once. */
        if (wrap && wrap.xzV2EarlyTap) {
          var earlyButton = wrap.querySelector('[data-sticky-buy]');
          if (earlyButton) earlyButton.removeEventListener('click', wrap.xzV2EarlyTap);
          wrap.xzV2EarlyTap = null;
        }
        if (!this.pdp || !this.main || !wrap || !wrap.querySelector('[data-sticky-buy]')) return;
        if (!early) {
          /* One button per page (the inline script leaves a second block's copy in place the same way). */
          if (document.querySelector('body > .xz-v2-pdp-sticky-portal')) return;
          document.body.appendChild(wrap);
        }
        this.portal = wrap;
        /* Shown in the first restored frame by the block's inline script. */
        this.visible = wrap.classList.contains('is-visible');
        this.button = wrap.querySelector('[data-sticky-buy]');
        this.label = wrap.querySelector('[data-sticky-label]');
        this.abort = new AbortController();
        var signal = this.abort.signal;
        var self = this;
        /* A reload or Back restores the scroll position, in WebKit after DCL: the button takes the restored
           state at once, as in the first frame, until the shopper's first input or 1s after load. */
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        this.restoring = !!nav && (nav.type === 'reload' || nav.type === 'back_forward');
        if (this.restoring) {
          var settle = function () { self.restoring = false; };
          ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (type) {
            window.addEventListener(type, settle, { passive: true, once: true, capture: true, signal: signal });
          });
          var afterLoad = function () { setTimeout(settle, 1000); };
          if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true, signal: signal });
        }
        this.footer = document.querySelector('.shopify-section-group-footer-group');
        var ticking = false;
        var measure = function () {
          ticking = false;
          if (!self.main.isConnected) self.refreshMain();
          var vh = window.innerHeight;
          self.pastTrigger = self.pdp.getBoundingClientRect().bottom < vh - STICKY_OFFSET;
          self.atFooter = !!(self.footer && self.footer.getBoundingClientRect().top < vh);
          self.update();
        };
        var schedule = function () { if (!ticking) { ticking = true; requestAnimationFrame(measure); } };
        window.addEventListener('scroll', schedule, { passive: true, signal: signal });
        window.addEventListener('resize', schedule, { passive: true, signal: signal });
        window.addEventListener('load', schedule, { once: true, signal: signal });
        /* Back from the bfcache: the page comes back as it was left; any change is taken at once. */
        window.addEventListener('pageshow', function (event) {
          if (!event.persisted) return;
          var was = self.restoring;
          self.restoring = true;
          measure();
          self.restoring = was;
        }, { signal: signal });
        /* Content above the trigger that changes height (accordions, late images) moves it without a scroll. */
        if ('ResizeObserver' in window) {
          this.resizer = new ResizeObserver(schedule);
          this.resizer.observe(document.body);
        }
        this.watchStrips();
        measure();
        this.button.addEventListener('click', function (event) { self.buy(event); }, { signal: signal });
        /* While the button is up, a control that takes focus behind it is scrolled clear (WCAG 2.4.11). The
           browser's own focus scroll already honours the scroll-padding; this covers engines that do not. */
        document.addEventListener('focusin', function () {
          if (self.visible) requestAnimationFrame(function () { self.unobscureFocus(); });
        }, { signal: signal });
        this.mirror = new MutationObserver(function () { self.syncLabel(); syncPrices(self.pdp); });
        this.mirror.observe(this.main, { attributes: true, childList: true, subtree: true, characterData: true });
        var priceNode = this.pdp.querySelector('product-price');
        if (priceNode) this.mirror.observe(priceNode, { childList: true, subtree: true, characterData: true });
        this.syncLabel();
        syncPrices(this.pdp);
      }
      refreshMain() {
        var next = this.pdp.querySelector('.product-form-buttons .add-to-cart-button');
        if (!next || next === this.main) return;
        this.main = next;
        this.mirror.observe(next, { attributes: true, childList: true, subtree: true, characterData: true });
        this.syncLabel();
      }
      /* The main button's label (Add to cart / Sold out / Pre-order) and its disabled look. */
      syncLabel() {
        if (!this.main.isConnected) this.refreshMain();
        var text = this.main.querySelector('.add-to-cart-text__content');
        var value = (text ? text.textContent : this.main.textContent).trim();
        if (value && this.label.textContent !== value) this.label.textContent = value;
        this.portal.classList.toggle('is-disabled', this.main.disabled);
      }
      watchStrips() {
        /* Never show two gold buy buttons at once: the button steps aside while an in-page buy strip (knife
           landing; not rendered since 2 Oct, kept in the templates) is on screen. */
        var self = this;
        this.stripsInView = 0;
        this.stripsKnown = true;
        if (!('IntersectionObserver' in window)) return;
        var strips = document.querySelectorAll('[data-klp-buy-strip]');
        /* Until the observer's first report the strips' state is unknown: showing the button then could bring it
           in and straight back out. */
        this.stripsKnown = !strips.length;
        if (!strips.length) return;
        this.stripObserver = new IntersectionObserver(function (entries) {
          self.stripsKnown = true;
          entries.forEach(function (entry) {
            var was = entry.target.__xzInView === true;
            if (entry.isIntersecting === was) return;
            entry.target.__xzInView = entry.isIntersecting;
            self.stripsInView += entry.isIntersecting ? 1 : -1;
          });
          self.update();
        });
        strips.forEach(function (strip) { self.stripObserver.observe(strip); });
      }
      update() {
        if (!this.stripsKnown) return;
        var show = !!this.pastTrigger && !this.atFooter && !(this.stripsInView > 0);
        if (show === this.visible) return;
        this.setVisible(show, !this.restoring);
      }
      setVisible(show, animate) {
        var wrap = this.portal, button = this.button, self = this;
        this.visible = show;
        wrap.inert = !show;
        /* Browsers without inert (iOS before 15.5, Chrome before 102, Firefox before 112): out of the tab order and,
           with the CSS's pointer-events:none, untappable while it fades out; a focused button lets go of focus. */
        button.tabIndex = show ? 0 : -1;
        if (!show && document.activeElement === button) button.blur();
        document.documentElement.classList.toggle('xz-v2-has-sticky-buy', show);
        /* From the current look, read before the running animation is cancelled (Milen's script); from the start
           state while the wrapper is display:none (no computed transform there). */
        var from = null;
        if (animate && typeof button.animate === 'function') {
          if (!this.anim && !wrap.classList.contains('is-visible') && !wrap.classList.contains('is-leaving')) {
            from = { opacity: '0', transform: 'translateY(20px)' };
          } else {
            var current = getComputedStyle(button);
            from = { opacity: current.opacity, transform: current.transform };
          }
        }
        if (this.anim) { this.anim.cancel(); this.anim = null; }
        /* The classes hold the end state (shown, or display:none once an exit has finished). */
        wrap.classList.toggle('is-visible', show);
        wrap.classList.toggle('is-leaving', !show && !!from);
        if (from) {
          var to = { opacity: show ? '1' : '0', transform: show ? 'translateY(0px)' : 'translateY(20px)' };
          if (reduceMotion) { delete from.transform; delete to.transform; }
          var anim = this.anim = button.animate([from, to], { duration: STICKY_MS, easing: STICKY_EASE });
          anim.onfinish = function () {
            if (self.anim !== anim) return;
            self.anim = null;
            if (!self.visible) wrap.classList.remove('is-leaving');
          };
        }
        /* The scroll that brought the button in can be the browser's own focus scroll (Tab onto a control at the
           bottom edge): the scroll-padding did not exist yet, so that control may now sit under the button. */
        if (show) requestAnimationFrame(function () { self.unobscureFocus(); });
      }
      unobscureFocus() {
        if (!this.visible || !this.portal) return;
        var el = document.activeElement;
        if (!el || el === document.body || el === document.documentElement || this.portal.contains(el)) return;
        if (el.closest && el.closest('dialog[open], [aria-modal="true"]')) return;
        /* Keyboard focus (and text fields) only: a control clicked earlier must not pull the page while the
           shopper scrolls with the wheel or a finger. */
        try { if (!el.matches(':focus-visible')) return; } catch (e) {}
        var rect = el.getBoundingClientRect();
        if (!rect.width && !rect.height) return;
        /* Under the button (its column, from the wrapper's top edge, Milen's 16px above it): scroll it clear;
           'nearest' then honours the scroll-padding. */
        var top = this.portal.getBoundingClientRect().top, b = this.button.getBoundingClientRect();
        if (rect.bottom > top && rect.top < window.innerHeight && rect.right > b.left && rect.left < b.right) {
          el.scrollIntoView({ block: 'nearest' });
        }
      }
      /* An add from the button that fails shows its message beside the main button, far up the page: once that
         add has finished (product-form.js holds aria-busy on the main button while it is in flight), bring the
         main button and its message into view. The live region still announces it. */
      watchAdd(keyboard) {
        var self = this, main = this.main;
        if (this.addWatch) this.addWatch();
        if (!('MutationObserver' in window)) return;
        var started = main.getAttribute('aria-busy') === 'true';
        var observer, timer;
        var stop = function () {
          if (observer) observer.disconnect();
          clearTimeout(timer);
          if (self.addWatch === stop) self.addWatch = null;
        };
        observer = new MutationObserver(function () {
          if (main.getAttribute('aria-busy') === 'true') { started = true; return; }
          if (!started) return;
          stop();
          self.revealAddError(main, keyboard);
        });
        observer.observe(main, { attributes: true, attributeFilter: ['aria-busy'] });
        /* Capped: an add that never starts (invalid form) or never settles stops being watched after 10s. */
        timer = setTimeout(stop, 10000);
        this.addWatch = stop;
        if (this.abort) this.abort.signal.addEventListener('abort', stop, { once: true });
      }
      revealAddError(main, keyboard) {
        var form = main.closest('product-form-component') || main.form;
        var error = form && form.querySelector('.product-form-text__error');
        if (!error || error.classList.contains('hidden') || !error.getClientRects().length) return;
        var a = main.getBoundingClientRect(), e = error.getBoundingClientRect();
        var top = Math.min(a.top, e.top), bottom = Math.max(a.bottom, e.bottom);
        /* Centre the pair (block 'center'); if both do not fit, centre the message. */
        var middle = bottom - top <= window.innerHeight * 0.8 ? (top + bottom) / 2 : (e.top + e.bottom) / 2;
        var y = (window.pageYOffset || document.documentElement.scrollTop) + middle - window.innerHeight / 2;
        try { window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, Math.max(0, y)); }
        /* Keyboard buy: focus follows to the main button (the floating button goes inert as it hides). */
        if (keyboard) { try { main.focus({ preventScroll: true }); } catch (err) { main.focus(); } }
      }
      buy(event) {
        /* Enter/Space on a button dispatches a click with detail 0; pointer and touch clicks count >= 1. */
        var keyboard = !!event && event.detail === 0;
        if (engravingNeedsText(this.pdp)) { promptEngraving(this.pdp); return; }
        if (this.main.disabled) {
          /* Sold out: blocks/buy-buttons.liquid swaps the main button for Notify me in the same row; bring the row
             into view (the hidden button itself has no box to scroll to). */
          var row = this.main.getClientRects().length ? this.main : (this.main.closest('.product-form-buttons') || this.main);
          row.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
          return;
        }
        if (!this.main.isConnected) this.refreshMain();
        /* product-form.js marks the main button aria-busy while its add is in flight: a second tap on the
           floating button then adds nothing (one tap, one knife; the main button has the same guard). */
        if (this.main.getAttribute('aria-busy') === 'true') return;
        /* A required field left empty (gift card: Recipient chosen, no email): the click below shows the browser's
           message on it, but its own scroll can leave the field under the fixed header (1440). Centre it first. */
        var form = this.main.form;
        if (form && !form.checkValidity()) {
          var bad = form.querySelector('input:invalid, textarea:invalid, select:invalid');
          if (bad) bad.scrollIntoView({ block: 'center' });
        }
        this.main.click();
        this.watchAdd(keyboard);
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.abort = null;
        if (this.mirror) this.mirror.disconnect();
        if (this.resizer) this.resizer.disconnect();
        this.resizer = null;
        if (this.stripObserver) this.stripObserver.disconnect();
        this.stripObserver = null;
        if (this.anim) { this.anim.cancel(); this.anim = null; }
        if (this.portal) {
          var wrap = this.portal;
          wrap.classList.remove('is-visible', 'is-leaving');
          wrap.inert = true;
          this.appendChild(wrap);
          this.portal = null;
        }
        document.documentElement.classList.remove('xz-v2-has-sticky-buy');
        this.visible = undefined;
      }
    });
  }
})();
